import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Tone = "default" | "gold" | "green" | "amber" | "red" | "blue";
type Modifier = "none" | "dot" | "pulse";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  modifier?: Modifier;
}

const toneClass: Record<Tone, string> = {
  default: "",
  gold: "badge-gold",
  green: "badge-green",
  amber: "badge-amber",
  red: "badge-red",
  blue: "badge-blue",
};

const modifierClass: Record<Modifier, string> = {
  none: "",
  dot: "badge-dot",
  pulse: "badge-pulse",
};

export function Badge({ tone = "default", modifier = "none", className, ...rest }: BadgeProps) {
  return (
    <span className={cn("badge", toneClass[tone], modifierClass[modifier], className)} {...rest} />
  );
}

/** Convenience pro mapping z DB statusu — použij `<StatusBadge meta={...}>`. */
export interface StatusBadgeProps {
  meta: { label: string; badgeClass: string } | null;
}

export function StatusBadge({ meta }: StatusBadgeProps) {
  if (!meta) return null;
  return <span className={cn("badge", meta.badgeClass)}>{meta.label}</span>;
}
